class TougeCrossSell extends HTMLElement {
  connectedCallback() {
    this.load();
  }

  money(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  resizedUrl(url, size) {
    if (!url) return url;
    return url.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_' + size + 'x$1$2');
  }

  async load() {
    try {
      const cartRes = await fetch('/cart.js');
      if (!cartRes.ok) return this.remove();
      const cart = await cartRes.json();
      if (!cart.items || !cart.items.length) return this.remove();

      const cartProductIds = cart.items.map((item) => item.product_id);
      const lastItem = cart.items[cart.items.length - 1];
      const productId = lastItem.product_id;

      // As duas chamadas de recomendação (complementar e relacionada) não
      // dependem uma da outra — antes rodavam em série (só pedia "related"
      // depois que "complementary" voltava vazio), somando o tempo das duas
      // chamadas de rede. Pedindo as duas ao mesmo tempo com Promise.all,
      // o tempo total vira o da mais lenta das duas, não a soma.
      const [complementary, related] = await Promise.all([
        this.fetchRecommendations(productId, 'complementary'),
        this.fetchRecommendations(productId, 'related'),
      ]);
      let products = complementary.length ? complementary : related;

      products = products.filter((p) => !cartProductIds.includes(p.id)).slice(0, 2);

      if (!products.length) return this.remove();
      this.renderCards(products);
    } catch (err) {
      this.remove();
    }
  }

  async fetchRecommendations(productId, intent) {
    const res = await fetch(
      `/recommendations/products.json?product_id=${productId}&limit=4&intent=${intent}`
    );
    if (!res.ok) return [];
    const data = await res.json();
    return data.products || [];
  }

  renderCards(products) {
    const cards = products
      .map((p) => {
        const img = this.resizedUrl(p.featured_image, 200);
        const onSale = p.compare_at_price && p.compare_at_price > p.price;
        const compareHtml = onSale
          ? `<s class="touge-cross-sell__compare">${this.money(p.compare_at_price)}</s>`
          : '';
        return `
          <a href="${p.url}" class="touge-cross-sell__card">
            <div class="touge-cross-sell__img">${
              img ? `<img src="${img}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy" width="80" height="80">` : ''
            }</div>
            <div class="touge-cross-sell__info">
              <p class="touge-cross-sell__title">${p.title}</p>
              <p class="touge-cross-sell__price">${compareHtml}<span>${this.money(p.price)}</span></p>
            </div>
          </a>`;
      })
      .join('');

    this.innerHTML = `
      <p class="touge-cross-sell__label">COMPRE JUNTO</p>
      <div class="touge-cross-sell__row">${cards}</div>
    `;
  }
}

if (!customElements.get('touge-cross-sell')) {
  customElements.define('touge-cross-sell', TougeCrossSell);
}
